import { Button, ButtonProps, Text } from "@chakra-ui/react";
import { RiExternalLinkLine, RiFileCodeLine } from "@remixicon/react";

type DocumentationRefButtonProps = Omit<
  ButtonProps,
  | "as"
  | "href"
  | "justifyContent"
  | "leftIcon"
  | "rightIcon"
  | "target"
  | "variant"
> & {
  title?: string;
  section?: string;
  fullSize?: boolean;
};

export function DocumentationRefButton({
  title = "Open docs",
  section,
  fullSize = false,
  ...props
}: DocumentationRefButtonProps) {
  return (
    <Button
      as="a"
      color="dimmed"
      display="inline-flex"
      fontSize={"sm"}
      href={`https://docs.reflag.com/${section ?? ""}`}
      justifyContent="space-between"
      leftIcon={fullSize ? <RiFileCodeLine size={18} /> : undefined}
      px={fullSize ? 2.5 : 1.5}
      rightIcon={<RiExternalLinkLine size={fullSize ? 16 : 12} />}
      size={!fullSize ? "xs" : undefined}
      target="_blank"
      variant={fullSize ? "outline" : "ghost"}
      {...props}
    >
      <Text flexGrow={1}>{title}</Text>
    </Button>
  );
}
